export default "__VITE_ASSET__DU7K8qj5__"